import * as React from 'react';
import SidebarAdmin from '../../components/admin/Sidebar';
import { Typography } from "@mui/material"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "../../css/seller/ListTransaction.css";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';
import LoadingScreen from '../../components/LoadingScreen';

export default function AdminListTrans() {
  const headerTable = {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '29px',
    color: '#000000',
  }

  const rowTable = {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    color: '#000000',
  }

  const [isLoading, setIsLoading] = React.useState(false);
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [transaction, setTransaction] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    const validateAccessToken = async () => {
      try {
        setIsLoading(true);
        const url = 'https://w-shop-backend.vercel.app/api/transactions';
        const rawResponse = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        });
        const response = await rawResponse.json();
        if (response.status !== 'success') {
          throw new Error(response.message);
        } else {
          setTransaction(response.data);
          setIsLoading(false)
        }
      } catch (error) {
        setCookie('accessToken', '', { path: '/' });
        navigate('/sellerLogin');
      }
    }
    if (cookies.accessToken === '') {
      navigate('/sellerLogin');
    } else {
      validateAccessToken();
    }
  }, [cookies, navigate, setCookie])

  function createData(codeTrans, user, product, amount, totalPrice, transactionTime) {
    return { codeTrans, user, product, amount, totalPrice, transactionTime };
  }
  const rows = [];

  transaction.map((transactions) => {
    return (transactions.status === true ? (rows.push(createData(
      transactions.codeTrans, transactions.user.name,
      transactions.product.product,
      transactions.amount,
      new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(transactions.price * transactions.amount),
      new Date(transactions.updatedAt).toLocaleString()))
    ) : (null))
  });

  let sort = rows.reverse();
  let limitRows
  sort.length < 30 ? (limitRows = 30) : (limitRows = sort.length)

  const limit = [];
  for (let index = 0; index < limitRows; index++) {
    if (sort[index] !== undefined) {
      limit.push(sort[index]);
    } else {
      limit.push(createData('', '', '', '', '', ''))
    }
  }

  let ListTransaction = (<div className='ticket-db-main p-5 pt-3'>
    <LoadingScreen active={isLoading} />
    <div className="backgroundTable">
      <h4 className="content2 mb-5">Transaksi Terbaru</h4>
      <TableContainer component={Paper} sx={{ marginBottom: '10px' }}>
        <Table aria-label="a dense table">
          <TableHead className="headerTable">
            <TableRow >
              <TableCell sx={headerTable}>Kode Transaksi</TableCell>
              <TableCell sx={headerTable}>Pembeli</TableCell>
              <TableCell sx={headerTable} >Produk</TableCell>
              <TableCell sx={headerTable} >Jumlah</TableCell>
              <TableCell sx={headerTable} >Total Harga</TableCell>
              <TableCell sx={headerTable} >Waktu Transaksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {limit.map((row, i) => (
              <TableRow key={i} sx={{ height: '0px', }}>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px', background: 'rgba(0, 102, 255, 0.25)' }}>
                  <Typography sx={rowTable}>{row.codeTrans}</Typography>
                </TableCell>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.user}</Typography></TableCell>
                <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.product}</Typography></TableCell>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.amount}</Typography></TableCell>
                <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.totalPrice}</Typography></TableCell>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.transactionTime}</Typography></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <a className="linkk justify-content-start" href='/adminDashboard'>{"<<"} Kembali </a>
    </div><br />
  </div>)
  return (
    <div>
      <SidebarAdmin components={ListTransaction} titleAppBar={"Dashboard"} />
    </div>
  );
}
